import Vue from 'vue'
import VueRouter from "vue-router"
// 前台页面组件（已保留你现有组件）
import Home from '../views/Home/home.vue'
import Detail from '../views/Detail/detail.vue'
import Contact from '../views/Contact/contact.vue'
import Report from '../views/Contact/report.vue'
import Designer from '../views/Designer/designer.vue'
import Login from '../views/Login/login.vue'
import Upload from '../views/Upload/upload.vue'
import ExitModel from '../views/Upload/exitModel.vue'
import My from '../views/My/my.vue' // 买家中心主框架
import My2 from '../views/My/my2.vue' // 新增：卖家中心主框架
import Charging from '../views/Charging/charging.vue'
import Footprint from '../views/Footprint/footprint.vue'
import Search from '../views/Search/search.vue'
import Type from '../views/Search/type.vue'
import Designers from '../views/Search/designers.vue'
import HotModels from '../views/Search/hotModels.vue'
import ServiceProtocol from '../views/Protocol/service.vue'
import PrivacyPolicy from '../views/Protocol/privacy.vue'
import HelpDoc from '../views/Protocol/helpDoc.vue'
import RightsRules from '../views/Protocol/rightsRules.vue'
import BuyerDoc from '../views/Protocol/buyerDoc.vue'
import LicenseDoc from '../views/Protocol/licenseDoc.vue'
import RechargeDoc from '../views/Protocol/rechargeDoc.vue'
import PlatformIntro from '../views/Footer/platformIntro.vue'
import ContactUs from '../views/Footer/contactUs.vue'
import PlatformNews from '../views/Footer/platformNews.vue'

// 404页面
import NotFound from "../views/Error/404.vue"

// 新增：后台管理页面组件（对应拆分的子页面）
// 买家子页面（不变）
import BuyerHome from '../views/Dashboard/Buyer/home.vue'
import BuyerOrders from '../views/Dashboard/Buyer/orders.vue'
import BuyerCart from '../views/Dashboard/Buyer/cart.vue'
import BuyerRecharge from '../views/Dashboard/Buyer/recharge.vue'
import BuyerFunds from '../views/Dashboard/Buyer/funds.vue'
import BuyerInvoice from '../views/Dashboard/Buyer/invoice.vue'
import BuyerHistory from '../views/Dashboard/Buyer/history.vue'
import BuyerCollect from '../views/Dashboard/Buyer/collect.vue'
import BuyerSettings from '../views/Dashboard/Buyer/settings.vue'

// 卖家子页面（不变）
import SellerHome from '../views/Dashboard/Seller/home.vue'
import SellerPromotion from '../views/Dashboard/Seller/promotion.vue'
import SellerModels from '../views/Dashboard/Seller/models.vue'
import SellerInvoice from '../views/Dashboard/Seller/invoice.vue'
import SellerApply from '../views/Dashboard/Seller/apply.vue'
import SellerCategory from '../views/Dashboard/Seller/category.vue'
import SellerTemplates from '../views/Dashboard/Seller/templates.vue'
import SellerOrders from '../views/Dashboard/Seller/orders.vue'
import SellerRefund from '../views/Dashboard/Seller/refund.vue'
import SellerComments from '../views/Dashboard/Seller/comments.vue'
import SellerAnalysis from '../views/Dashboard/Seller/analysis.vue'
import SellerTraffic from '../views/Dashboard/Seller/traffic.vue'
import SellerUsers from '../views/Dashboard/Seller/users.vue'
import SellerWithdraw from '../views/Dashboard/Seller/withdraw.vue'
import SellerInfo from '../views/Dashboard/Seller/info.vue'
import SellerEnterprise from '../views/Dashboard/Seller/enterprise.vue'

// 购物车结算相关页面（不变）
import OrderConfirm from '../views/Dashboard/Buyer/orderConfirm.vue'
import Payment from '../views/Dashboard/Buyer/payment.vue'
import OrderDetail from '../views/Dashboard/Buyer/orderDetail.vue'

import {
  Message
} from 'element-ui'

Vue.use(VueRouter)

// 解决重复跳转路由报错（不变）
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  // 新增：开启history模式（如果未开启的话，保证scrollBehavior生效）
  // mode: 'history',
  // 核心修复：添加scrollBehavior配置，强制路由切换时滚动到顶部
  scrollBehavior(to, from, savedPosition) {
    // 1. 浏览器前进/后退时，恢复保存的滚动位置（保留原生体验）
    if (savedPosition) {
      return savedPosition;
    }
    // 2. 普通路由切换（包括子路由），强制滚动到顶部
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    // 重定向：默认跳转前台首页（不变）
    // {
    //   path: '',
    //   redirect: '/'
    // },

    // ---------------------- 底部导航可点击页面 ----------------------
    {
      path: "/platformIntro",
      component: PlatformIntro,
      meta: {
        title: '智步云上模型网-平台介绍',
        requireAuth: false
      }
    },
    {
      path: "/contactUs",
      component: ContactUs,
      meta: {
        title: '智步云上模型网-联系我们',
        requireAuth: false
      }
    },
    {
      path: "/platformNews",
      component: PlatformNews,
      meta: {
        title: '智步云上模型网-平台动态',
        requireAuth: false
      }
    },

    // ---------------------- 前台页面路由（保留你现有配置，仅放开my路由） ----------------------
    {
      path: '/',
      component: Home,
      meta: {
        title: '智步云上模型网',
        requireAuth: false,
      }
    },
    {
      path: "/contact",
      component: Contact,
      meta: {
        title: '智步云上模型网-联系我们',
        requireAuth: true
      }
    },
    {
      path: "/report",
      component: Report,
      meta: {
        title: '智步云上模型网-举报模型',
        requireAuth: true
      }
    },
    {
      path: '/detail',
      component: Detail,
      meta: {
        title: '智步云上模型网-模型详情',
        requireAuth: false
      }
    },
    {
      path: "/protocol/help-doc",
      component: HelpDoc,
      meta: {
        title: '智步云上模型网-通用格式购前帮助文档',
        requireAuth: false
      }
    },
    {
      path: "/protocol/rights-rules",
      component: RightsRules,
      meta: {
        title: '智步云上模型网-权利通知规则',
        requireAuth: false
      }
    },
    {
      path: "/protocol/buyer-doc",
      component: BuyerDoc,
      meta: {
        title: '智步云上模型网-买家协议',
        requireAuth: false
      }
    },
    {
      path: "/protocol/license-doc",
      component: LicenseDoc,
      meta: {
        title: '智步云上模型网-模型授权协议',
        requireAuth: false
      }
    },
    {
      path: "/protocol/recharge-doc",
      component: RechargeDoc,
      meta: {
        title: '智步云上模型网-充值协议',
        requireAuth: false
      }
    },
    {
      path: '/designer',
      component: Designer,
      meta: {
        title: '智步云上模型网-设计师',
        requireAuth: false
      }
    },
    {
      path: '/upload',
      component: Upload,
      meta: {
        title: '智步云上模型网-上传模型',
        requireAuth: true
      }
    },
    {
      path: '/exitModel',
      component: ExitModel,
      meta: {
        title: '智步云上模型网-修改模型',
        requireAuth: true
      }
    },
    // 恢复my路由：作为买家中心的快捷入口（可选，也可仅通过dashboard/buyer访问）
    {
      path: "/my",
      component: My,
      meta: {
        title: '智步云上模型网-买家中心',
        requireAuth: true
      },
      // my页面默认跳转到买家首页
      redirect: '/dashboard/buyer/home'
    },
    // 新增my2路由：作为卖家中心的快捷入口
    {
      path: "/my2",
      component: My2,
      meta: {
        title: '智步云上模型网-卖家中心',
        requireAuth: true
      },
      // my2页面默认跳转到卖家首页
      redirect: '/dashboard/seller/home'
    },
    {
      path: "/charging",
      component: Charging,
      meta: {
        title: '智步云上模型网-充值',
        requireAuth: true
      }
    },
    {
      path: "/footprint",
      component: Footprint,
      meta: {
        title: '智步云上模型网-我的足迹',
        requireAuth: true
      }
    },
    {
      path: "/search",
      component: Search,
      meta: {
        title: '智步云上模型网-搜索结果',
        requireAuth: false
      }
    },
    {
      path: "/type",
      component: Type,
      meta: {
        title: '智步云上模型网-分类',
        requireAuth: false
      }
    },
    {
      path: "/designers",
      component: Designers,
      meta: {
        title: '智步云上模型网-模型师',
        requireAuth: false
      }
    },
    {
      path: "/hotModels",
      component: HotModels,
      meta: {
        title: '智步云上模型网-模型推荐',
        requireAuth: false
      }
    },
    {
      path: "/login",
      component: Login,
      meta: {
        title: '智步云上模型网-登录',
        requireAuth: false,
      }
    },
    // 新增：服务协议页面路由
    {
      path: "/protocol/service",
      component: ServiceProtocol,
      meta: {
        title: '智步云上模型网-服务协议',
        requireAuth: false // 协议页面无需登录即可访问
      }
    },
    // 新增：隐私政策页面路由
    {
      path: "/protocol/privacy",
      component: PrivacyPolicy,
      meta: {
        title: '智步云上模型网-隐私政策',
        requireAuth: false // 隐私政策无需登录即可访问
      }
    },

    // ---------------------- 调整后：后台管理页面路由 ----------------------
    // 1. 买家中心主路由（对应my.vue）
    {
      path: '/dashboard/buyer',
      component: My, // 买家中心主框架（my.vue）
      meta: {
        title: '智步云上模型网-买家中心',
        requireAuth: true
      },
      children: [{
          path: 'home',
          component: BuyerHome,
          meta: {
            title: '智步云上模型网-买家首页'
          }
        },
        {
          path: 'orders',
          component: BuyerOrders,
          meta: {
            title: '智步云上模型网-我的订单'
          }
        },
        {
          path: 'cart',
          component: BuyerCart,
          meta: {
            title: '智步云上模型网-我的购物车'
          }
        },
        {
          path: 'recharge',
          component: BuyerRecharge,
          meta: {
            title: '智步云上模型网-充值中心'
          }
        },
        {
          path: 'funds',
          component: BuyerFunds,
          meta: {
            title: '智步云上模型网-资金明细'
          }
        },
        {
          path: 'invoice',
          component: BuyerInvoice,
          meta: {
            title: '智步云上模型网-发票管理'
          }
        },
        {
          path: 'history',
          component: BuyerHistory,
          meta: {
            title: '智步云上模型网-我的足迹'
          }
        },
        {
          path: 'collect',
          component: BuyerCollect,
          meta: {
            title: '智步云上模型网-我的收藏'
          }
        },
        {
          path: 'settings',
          component: BuyerSettings,
          meta: {
            title: '智步云上模型网-账户设置'
          }
        },
        // 买家子路由默认跳转首页
        {
          path: '',
          redirect: 'home'
        }
      ]
    },

    // 2. 卖家中心主路由（对应my2.vue）
    {
      path: '/dashboard/seller',
      component: My2, // 卖家中心主框架（my2.vue）
      meta: {
        title: '智步云上模型网-卖家中心',
        requireAuth: true
      },
      children: [{
          path: 'home',
          component: SellerHome,
          meta: {
            title: '智步云上模型网-商户首页'
          }
        },
        {
          path: 'promotion',
          component: SellerPromotion,
          meta: {
            title: '智步云上模型网-限时特惠'
          }
        },
        {
          path: 'models',
          component: SellerModels,
          meta: {
            title: '智步云上模型网-模型管理'
          }
        },
        {
          path: 'invoice',
          component: SellerInvoice,
          meta: {
            title: '智步云上模型网-开票管理'
          }
        },
        {
          path: 'apply',
          component: SellerApply,
          meta: {
            title: '智步云上模型网-发票管理'
          }
        },
        {
          path: 'category',
          component: SellerCategory,
          meta: {
            title: '智步云上模型网-分类管理'
          }
        },
        {
          path: 'templates',
          component: SellerTemplates,
          meta: {
            title: '智步云上模型网-模板设置'
          }
        },
        {
          path: 'orders',
          component: SellerOrders,
          meta: {
            title: '智步云上模型网-订单处理'
          }
        },
        {
          path: 'refund',
          component: SellerRefund,
          meta: {
            title: '智步云上模型网-退款管理'
          }
        },
        {
          path: 'comments',
          component: SellerComments,
          meta: {
            title: '智步云上模型网-评价管理'
          }
        },
        {
          path: 'analysis',
          component: SellerAnalysis,
          meta: {
            title: '智步云上模型网-销售分析'
          }
        },
        {
          path: 'traffic',
          component: SellerTraffic,
          meta: {
            title: '智步云上模型网-流量分析'
          }
        },
        {
          path: 'users',
          component: SellerUsers,
          meta: {
            title: '智步云上模型网-用户分析'
          }
        },
        {
          path: 'withdraw',
          component: SellerWithdraw,
          meta: {
            title: '智步云上模型网-提现管理'
          }
        },
        {
          path: 'info',
          component: SellerInfo,
          meta: {
            title: '智步云上模型网-实名认证'
          }
        },
        {
          path: 'enterprise',
          component: SellerEnterprise,
          meta: {
            title: '智步云上模型网-企业认证'
          }
        },
        // 卖家子路由默认跳转首页
        {
          path: '',
          redirect: 'home'
        }
      ]
    },

    // 3. 购物车-结算流程路由（调整路径，匹配新的买家路由结构）
    {
      path: '/dashboard/buyer/order-confirm',
      component: OrderConfirm,
      meta: {
        title: '智步云上模型网-订单确认',
        requireAuth: true
      }
    },
    {
      path: '/dashboard/buyer/payment/:orderNo',
      component: Payment,
      meta: {
        title: '智步云上模型网-订单支付',
        requireAuth: true
      }
    },
    {
      path: '/dashboard/buyer/order-detail/:orderNo',
      component: OrderDetail,
      meta: {
        title: '智步云上模型网-订单详情',
        requireAuth: true
      }
    },

    // 4. 根dashboard路由重定向（可选，方便访问）
    {
      path: '/dashboard',
      redirect: '/dashboard/buyer/home',
      meta: {
        requireAuth: true
      }
    },

    // ---------------------- 404页面（不变） ----------------------
    {
      path: "*",
      name: "NotFound",
      component: NotFound,
      meta: {
        title: '智步云上模型网-页面不存在'
      }
    }
  ]
});

// ---------------------- 全局路由守卫（不变） ----------------------
router.beforeEach((to, from, next) => {
  // 1. 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 2. 登录验证
  const token = localStorage.getItem('token');
  if (to.meta.requireAuth) {
    if (token) {
      next();
    } else {
      next('/login');
      Message({
        message: '请先登录后再操作！',
        type: 'warning'
      });
    }
  } else {
    next();
  }
});

export default router;